import React, { useState } from "react";

// ─── Update these when details are confirmed ──────────────────────────────────
const CONF = {
  dates: "October 23–24, 2026",
  location: "Calvary Baptist Church",
  registrationUrl: "https://cbcky.churchcenter.com/registrations/events/3712556",
  cost: "TBD",
  verse: '"Do not be afraid of them. Remember the Lord, who is great and awesome, and fight for your brothers, your sons, your daughters, your wives, and your homes." – Nehemiah 4:14',
};
// ─────────────────────────────────────────────────────────────────────────────

const DEPLOY_LETTERS = [
  {
    letter: "D",
    title: "Discover Your Calling",
    desc: "Understanding your Matthew 28 assignment",
    speaker: "Chris",
  },
  {
    letter: "E",
    title: "Equip Yourself for Gospel Readiness",
    desc: "Testimony, gospel clarity, overcoming fear",
    speaker: "Jeff",
  },
  {
    letter: "P",
    title: "Practice Everyday Mission",
    desc: "Role-play, conversation starters, gospel drills",
    speaker: "Jeff",
  },
  {
    letter: "L",
    title: "Live Sent With Integrity",
    desc: "Character, consistency, living missionally",
    speaker: "Jeff",
  },
  {
    letter: "O",
    title: "Others",
    desc: "Complete your Area of Operation Card — your mission field, your people",
    speaker: "",
  },
  {
    letter: "Y",
    title: "Your Next Step",
    desc: "One man, one habit, one prayer",
    speaker: "",
  },
];

const FRIDAY = [
  { time: "6:00 PM", session: "Dinner & Fellowship", details: "Check-in, dinner served, meet new people, table assignments", tag: null },
  { time: "6:45 PM", session: "Welcome & Vision", details: "Conference overview, DEPLOY theme, PACE card, Area of Operation card", tag: null },
  { time: "7:00 PM", session: "Worship Set #1", details: "2–3 songs", tag: "worship" },
  { time: "7:20 PM", session: "D – Discover Your Calling", details: "Understanding your Matthew 28 assignment", tag: "D", speaker: "Chris" },
  { time: "8:00 PM", session: "Table Discussion #1", details: "Who discipled you? When did your faith become real? Where has God positioned you?", tag: "discussion" },
  { time: "8:20 PM", session: "Giveaway #1", details: "Study Bible, leather journal, pocket knife", tag: "giveaway" },
  { time: "8:25 PM", session: "Fellowship & Activities", details: "Fire pit, axe throwing, cornhole, coffee & snacks", tag: null },
  { time: "9:15 PM", session: "Closing Thought & Prayer", details: "Brief challenge and prayer", tag: null },
  { time: "9:30 PM", session: "Dismiss", details: "End of evening session", tag: "end" },
];

const SATURDAY = [
  { time: "9:00 AM", session: "Coffee & Fellowship", details: "Arrival and fellowship", tag: null },
  { time: "9:15 AM", session: "Worship Set #2", details: "2 songs", tag: "worship" },
  { time: "9:30 AM", session: "E – Equip Yourself for Gospel Readiness", details: "Testimony, gospel clarity, overcoming fear", tag: "E", speaker: "Jeff" },
  { time: "10:20 AM", session: "Table Discussion #2", details: "Fears, obstacles, missed opportunities", tag: "discussion" },
  { time: "10:40 AM", session: "Giveaway #2", details: "Tactical flashlight, multi-tool, 414 hoodie", tag: "giveaway" },
  { time: "10:45 AM", session: "Break & Fellowship", details: "Activities and refreshments", tag: null },
  { time: "11:15 AM", session: "P – Practice Everyday Mission", details: "Role-play, conversation starters, gospel drills", tag: "P", speaker: "Jeff" },
  { time: "11:55 AM", session: "K9 Demonstration", details: "Training, readiness, obedience, deployment", tag: "special" },
  { time: "12:20 PM", session: "Lunch", details: "Lunch and fellowship", tag: null },
  { time: "1:15 PM", session: "Fellowship Block", details: "Fire pit, axes, cornhole, speaker interaction", tag: null },
  { time: "2:15 PM", session: "Worship Set #3", details: "2 songs", tag: "worship" },
  { time: "2:25 PM", session: "L – Live Sent With Integrity", details: "Character, consistency, living missionally", tag: "L", speaker: "Jeff" },
  { time: "3:00 PM", session: "O – Others Workshop", details: "Complete Area of Operation Card", tag: "O" },
  { time: "3:10 PM", session: "Y – Your Next Step", details: "One man, one habit, one prayer", tag: "Y" },
  { time: "3:20 PM", session: "Grand Prize Giveaway", details: "Major prizes and sponsor giveaways", tag: "giveaway" },
  { time: "3:25 PM", session: "Final Charge & Prayer", details: "Commissioning challenge", tag: null },
  { time: "3:30 PM", session: "Conference Ends", details: "Dismiss", tag: "end" },
];

const DEPLOY_TAGS = new Set(["D", "E", "P", "L", "O", "Y"]);

const TAG_PILL = {
  D: "bg-blue-700 text-white",
  E: "bg-blue-700 text-white",
  P: "bg-blue-700 text-white",
  L: "bg-blue-700 text-white",
  O: "bg-blue-700 text-white",
  Y: "bg-blue-700 text-white",
  worship: "bg-purple-100 text-purple-800",
  discussion: "bg-amber-100 text-amber-800",
  giveaway: "bg-green-100 text-green-800",
  special: "bg-orange-100 text-orange-800",
};

const TAG_LABEL = {
  D: "DEPLOY: D", E: "DEPLOY: E", P: "DEPLOY: P",
  L: "DEPLOY: L", O: "DEPLOY: O", Y: "DEPLOY: Y",
  worship: "Worship", discussion: "Table Discussion",
  giveaway: "Giveaway", special: "K9 Demo",
};

function ScheduleRow({ item }) {
  const isCore = DEPLOY_TAGS.has(item.tag);
  return (
    <div className={`flex gap-3 py-3 border-b border-gray-100 last:border-0 ${isCore ? "bg-blue-50 -mx-4 px-4 rounded" : ""}`}>
      <div className="text-xs font-mono text-gray-400 w-[4.5rem] shrink-0 pt-0.5 tabular-nums">{item.time}</div>
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-2 mb-0.5">
          <span className={`font-semibold text-sm ${isCore ? "text-blue-900" : "text-gray-800"}`}>
            {item.session}
          </span>
          {item.tag && item.tag !== "end" && (
            <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${TAG_PILL[item.tag] || "bg-gray-100 text-gray-700"}`}>
              {TAG_LABEL[item.tag]}
            </span>
          )}
        </div>
        <p className="text-xs text-gray-500 leading-relaxed">{item.details}</p>
        {item.speaker && (
          <p className="text-xs text-blue-600 font-semibold mt-0.5">— {item.speaker}</p>
        )}
      </div>
    </div>
  );
}

export default function DeployConference() {
  const [activeDay, setActiveDay] = useState("friday");

  return (
    <div className="min-h-screen bg-gray-50">

      {/* ── Hero ── */}
      <div className="bg-slate-900">
        <div className="bg-black w-full flex justify-center">
          <img
            src="https://deploy-missonsconf2026.s3.us-east-1.amazonaws.com/deploy_pco_2.png"
            alt="DEPLOY Men's Conference 2026"
            className="max-h-[550px] w-full object-contain"
          />
        </div>
        <div className="text-white text-center px-4 py-10">
          <p className="text-slate-400 text-sm sm:text-base mb-6">
            {CONF.dates}&nbsp;&nbsp;·&nbsp;&nbsp;{CONF.location}
          </p>
          {CONF.registrationUrl ? (
            <a
              href={CONF.registrationUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-block bg-blue-600 hover:bg-blue-500 text-white font-bold px-10 py-4 rounded-lg text-lg transition"
            >
              Register Now
            </a>
          ) : (
            <span className="inline-block bg-slate-700 text-slate-300 font-semibold px-8 py-3 rounded-lg text-sm">
              Registration Opening Soon
            </span>
          )}
        </div>
      </div>

      {/* ── About ── */}
      <div className="max-w-3xl mx-auto px-4 py-12 text-center">
        <p className="text-lg text-gray-700 leading-relaxed mb-4">
          DEPLOY is a two-day men's conference designed to equip and encourage men to{" "}
          <strong>live on mission where God has placed them.</strong> Through worship,
          practical teaching, table discussions, fellowship, and hands-on activities,
          you'll discover your calling, gain confidence in sharing your faith, and
          develop a clear plan for your next step.
        </p>
        <p className="text-gray-600 leading-relaxed">
          Join us for a weekend of brotherhood, encouragement, and challenge as we learn
          to <strong>live sent</strong> with purpose and integrity.
        </p>
      </div>

      {/* ── DEPLOY Framework ── */}
      <div className="bg-slate-800 py-14 px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-white text-center text-2xl sm:text-3xl font-bold mb-1">
            The DEPLOY Framework
          </h2>
          <p className="text-slate-400 text-center text-sm mb-10">
            Six mission objectives. One weekend. A lifetime of impact.
          </p>
          <div className="grid grid-cols-6 gap-2">
            {DEPLOY_LETTERS.map(({ letter, title, desc, speaker }) => (
              <div key={letter} className="bg-slate-700 hover:bg-slate-600 transition rounded-xl p-3 flex flex-col">
                <div className="text-4xl font-black text-blue-400 leading-none mb-2">
                  {letter}
                </div>
                <div className="text-white font-bold text-xs mb-1">{title}</div>
                <div className="text-slate-300 text-xs leading-relaxed">{desc}</div>
                {speaker && (
                  <div className="text-blue-400 text-xs mt-auto pt-2 font-semibold tracking-wide">
                    {speaker}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── What to Expect ── */}
      <div className="max-w-4xl mx-auto px-4 py-14">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 text-center mb-8">
          What to Expect
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {[
            { icon: "🎵", label: "Worship" },
            { icon: "🎤", label: "Engaging Speakers" },
            { icon: "🐕", label: "K9 Demonstration" },
            { icon: "🎁", label: "Giveaways" },
            { icon: "🍖", label: "Great Food" },
            { icon: "🪓", label: "Axe Throwing" },
            { icon: "🌽", label: "Cornhole" },
            { icon: "🔥", label: "Campfire Fellowship" },
            { icon: "👥", label: "Table Discussions" },
          ].map(({ icon, label }) => (
            <div
              key={label}
              className="bg-white rounded-xl shadow-sm p-4 flex items-center gap-3 border border-gray-100"
            >
              <span className="text-2xl flex-shrink-0">{icon}</span>
              <span className="font-medium text-gray-700 text-sm">{label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* ── Schedule ── */}
      <div className="bg-white py-14 px-4">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 text-center mb-8">
            Conference Schedule
          </h2>

          {/* Day Tabs */}
          <div className="flex border-b border-gray-200 mb-6">
            {[
              { key: "friday", label: "Friday Evening" },
              { key: "saturday", label: "Saturday" },
            ].map(({ key, label }) => (
              <button
                key={key}
                onClick={() => setActiveDay(key)}
                className={`flex-1 py-3 text-sm font-semibold transition border-b-2 -mb-px ${
                  activeDay === key
                    ? "border-blue-600 text-blue-700"
                    : "border-transparent text-gray-400 hover:text-gray-600"
                }`}
              >
                {label}
              </button>
            ))}
          </div>

          <div>
            {(activeDay === "friday" ? FRIDAY : SATURDAY).map((item, i) => (
              <ScheduleRow key={i} item={item} />
            ))}
          </div>
        </div>
      </div>

      {/* ── Key Resources ── */}
      <div className="max-w-3xl mx-auto px-4 py-14">
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">
          Key Resources
        </h2>
        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-blue-600">
            <h3 className="font-bold text-gray-800 text-base mb-2">PACE Card</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Your personal action and accountability guide — a commitment to living
              on mission after the conference ends.
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-blue-600">
            <h3 className="font-bold text-gray-800 text-base mb-2">Area of Operation Card</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Identify where God has strategically placed you to make disciples —
              your mission field and your people.
            </p>
          </div>
        </div>
      </div>

      {/* ── Bottom CTA ── */}
      <div className="bg-blue-700 py-16 px-4 text-center text-white">
        <h2 className="text-2xl sm:text-3xl font-bold mb-2">Ready to Get in the Fight?</h2>
        <p className="text-blue-200 text-sm mb-8">
          {CONF.dates}&nbsp;&nbsp;·&nbsp;&nbsp;{CONF.location}
        </p>

        {CONF.registrationUrl ? (
          <a
            href={CONF.registrationUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-block bg-white text-blue-700 font-bold px-10 py-4 rounded-lg text-lg hover:bg-blue-50 transition"
          >
            Register Now
          </a>
        ) : (
          <p className="text-blue-200 font-semibold text-sm">
            Registration details coming soon — stay tuned.
          </p>
        )}

        <p className="text-blue-200 text-sm italic mt-10 max-w-xl mx-auto leading-relaxed">
          {CONF.verse}
        </p>
        <p className="text-blue-400 text-xs mt-3">414 Ministry · Calvary Baptist Church</p>
      </div>
    </div>
  );
}
